<!--专家任务列表-->
<template>
	<div>
		<el-table class="qcTable" :data="exportsListArrData.SamplingTasks" v-loading="loading">
			<el-table-column prop="Id" label="任务编号" min-width="100"></el-table-column>
			<el-table-column prop="Name" label="名称"></el-table-column>
			<el-table-column prop="CategoryName" label="类型">
				<template slot-scope="scope">
					<span v-if="scope.row.CategoryName=='影像'" title="影像">影像</span>
					<span v-else-if="scope.row.CategoryName=='报告'" title="报告">报告</span>
					<span v-else title="影像和报告">影像和报告</span>
				</template>
			</el-table-column>
			<el-table-column prop="Progress" v-if="statusList == '15,20'">
				<template slot-scope="scope" slot="header">
					<span>质控进度 </span>
					<!--<el-tooltip effect="dark" placement="bottom-start">
						<i class="el-icon-info" style="color: #ffb22c;"></i>
						<div slot="content" class="tableTooltip">
							<div>
								<em></em>
								<span>已完成</span>
							</div>
							<div>	
							<em></em>
							<span>进行中</span>
							</div>
							<div>此处显示比例为两者之和</div>
						</div>
					</el-tooltip>-->
				</template>
				<template slot-scope="scope">
					<el-tooltip effect="dark" placement="top-start">
						<div class="progress">
							<div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.CompleteCount/scope.row.DistributeCount)*100)}%`">
							</div>
							<!--<div class="progress-bar progress-bar-warning progress-bar-striped" :style="`width: ${Math.floor((scope.row.TmpSavedCount/scope.row.DistributeCount)*100)}%`">
							</div>-->
							<!--<span class="sr-only">{{(Math.floor((scope.row.TmpSavedCount/scope.row.DistributeCount)*100))+(Math.floor((scope.row.CompleteCount/scope.row.DistributeCount)*100))}}%</span>-->
							<span class="sr-only">{{(Math.floor((scope.row.CompleteCount/scope.row.DistributeCount)*100))}}%</span>
						</div>
						<div slot="content" class="tableTooltip">
							<div>
								<em></em>
								<span>已完成数量:{{scope.row.CompleteCount}}</span>
							</div>
					
						</div>
					</el-tooltip>
					
				</template>
			</el-table-column>
			<el-table-column v-if="statusList==-1" prop="CompleteCount" label="已完成"></el-table-column>
			<el-table-column prop="DistributeCount" label="总数"></el-table-column>
			<el-table-column prop="CreateDt" min-width="100" :formatter="formattertime" label="创建时间"></el-table-column>
			<el-table-column v-if="statusList!=-1" prop="ComepleteDt" :formatter="formattertime" min-width="100" label="完成时间"></el-table-column>
			<el-table-column prop="CreateorName" label="创建人"></el-table-column>
			<el-table-column prop="" label="操作" width="180">
				<template slot-scope="scope">
					<span class="tableOpe" @click="experClick(scope.row)">查看报告</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<style scoped>
	.el-form-item {
		margin-bottom: 10px !important;
	}
</style>
<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		data() {
			return {
				filtersz: [],
				recordExpands: '',
				expands: [],
				getRowKeys(row) {
					return row.Id
				},
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading']),
			...Vuex.mapState('managerPlanList', ['secondListParameter']),
			...Vuex.mapState('doctor', ['list', 'exportsListArrData', 'exportsListTitle', 'samplingTaskGuid', 'statusList']),
			percentages(row) {
				return Math.floor((row.CompleteCount / row.DistributeCount) * 100)
			}
		},
		created() {
			this.setqcresultsShow(false);
			if (this.statusList==0) {
				this.doctorDoctorStatus('15,20')
			}else{
				this.doctorDoctorStatus(this.statusList)
			}
			this.expertinfoGetTaskList();
		},
		methods: {
			...Vuex.mapMutations('breadcrumb',['setqcresultsShow']),
			...Vuex.mapMutations('managerPlanList', ['setSecondListParameter']),
			...Vuex.mapMutations('doctor', ['setTabShow','setIsSubmint','doctorDoctorStatus','isRole','setSplitScreen', 'exportDoctorStatus', 'setDetailsParameter', 'experListShow', 'experListShowMu', 'setIsSubmint', 'currentChangesSecond']),
			...Vuex.mapActions('managerPlanList', ['GetReportListByTask']),
			...Vuex.mapActions('doctor', ['expertinfoGetTaskList','GetReportDetail', 'GetExpertTaskList']),
			formattertime(row, column, cellValue){
				if (cellValue!=''&&cellValue!=null) {
					return cellValue.substring(0,cellValue.length-3);
				}else{
					return cellValue;
				}
				
			},
			distributionClick(row) {
				this.distributionBox.open = true;
			},
			expandSelect(row, expandedRows) {
				this.gotoSeccend(row)
			},
			handdle(row) {
				this.list.children = [];
				this.gotoSeccend(row)
			},

			gotoSeccend(row) {
				this.recordExpands = row.Id;
				if(this.expands[0] != this.recordExpands) {
					this.expands = []

					this.expands.push(row.Id)
				} else {
					this.expands = []
				}
				this.secondListParameter.HospitalUid = ''
				this.secondListParameter.DoctorType = '';
				this.secondListParameter.ModalityType =
					this.setSecondListParameter(row)
				this.GetReportListByTask()
			},

			handleClick(datas) {
				this.setSplitScreen(true);
				this.setDetailsParameter({
					reportGuid: datas.ReportGuid,
					samplingTaskGuid: datas.SamplingTaskGuid
				})
				this.GetReportDetail()
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			filterTagTable(filters) {
				let HospitalUid = [],
					DoctorType = [],
					ModalityType = []
				if(filters.HospitalUid) {
					HospitalUid = filters.HospitalUid.join(',')
				}
				if(filters.DoctorType) {
					DoctorType = filters.DoctorType.join(',')
				}
				if(filters.ModalityType) {
					ModalityType = filters.ModalityType.join(',')
				}
				this.secondListParameter.HospitalUid = HospitalUid
				this.secondListParameter.DoctorType = DoctorType
				this.secondListParameter.ModalityType = ModalityType
				this.GetReportListByTask()
				this.expands = []
				this.expands.push(this.recordExpands)

			},
			experClick(row) {
				this.setTabShow(true);
				this.exportsListTitle.name = row.Name;
				this.exportsListTitle.categoryName = row.CategoryName;
				this.samplingTaskGuid.id = row.SamplingTaskGuid;
				this.samplingTaskGuid.isUnqualified = false;
				this.isRole('export')
				this.$router.push('/home/experts/expertsTable');
			}

		}

	}
</script>